var protocolStr = document.location.protocol;
var VUE_APP_WSR_URL = "ws://";
if (protocolStr == "http:") {
  VUE_APP_WSR_URL = "ws://";
} else if (protocolStr == "https:") {
  VUE_APP_WSR_URL = "wss://";
}
export { VUE_APP_WSR_URL };
